import api from './index';

let exports = {};

// 获取指定工单的金额总和
exports.getWorkVoucherAmountByIds = function (data, callback) {// 获取指定工单的金额总和
    api.post('/servcDeliv/work/voucher/amount/get/by/ids')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 提取工单中所有零售商的设备标签
exports.getServcWorkVoucherDeviceBizTagList = function (data, callback) {
    api.post('/servcDeliv/servc/work/voucher/device/bizTag/list')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
//
exports.getServcWorkVoucherList = function (data, callback) {// 获取服务工单列表
    api.post('/servcDeliv/servc/work/voucher/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getGrabWorkList = function (data, callback) {// 获取服务工单列表
    api.post('/servcDeliv/grab/work/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.saveServcWorkVoucherForExport = function (data, callback) {// 获取服务工单列表
    api.post('/servcDeliv/servc/work/voucher/list/params/for/export/url')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getServcWorkVoucherListByOrderId = function (data, callback) {// 通过服务订单id获取服务工单列表
    api.post('/servcDeliv/servc/work/voucher/list/get/by/orderId')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getServcWorkVoucherDetail = function (params, callback) {// 通过服务工单id获取服务工单详情
    api.get('/servcDeliv/servc/work/voucher/detail/get')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.saveServcWorkVoucher = function (data, callback) {// 新增服务工单
    api.post('/servcDeliv/servc/work/voucher/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.changeServcWorkVoucher = function (data, callback) {// 转单操作
    api.post('/servcDeliv/servc/work/voucher/change/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.invalidatedServcWorkVoucher = function (params, callback) {// 作废操作
    api.post('/servcDeliv/servc/work/voucher/invalidated/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.closeServcWorkVoucher = function (params, callback) {// 关闭操作
    api.post('/servcDeliv/servc/work/voucher/close/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.closeServcWorkVoucherForBatch = function (data, callback) {// 关闭操作-批量
    api.post('/servcDeliv/servc/work/voucher/close/for/batch/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.relieveServcWorkVoucherStateInterrupt = function (params, callback) {// 解除暂停
    api.post('/servcDeliv/servc/work/voucher/state/interrupt/relieve/do')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.requestServcWorkVoucherAssist = function (data, callback) {// 支援升级
    api.post('/servcDeliv/servc/work/voucher/assist/request/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.updateServcWorkVoucherServicer = function (data, callback) {// 调度服务商
    api.post('/servcDeliv/servc/work/voucher/update/servicer/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.requestServcWorkVoucherDispatch = function (data, callback) {// 网点间调度
    api.post('/servcDeliv/servc/work/voucher/dispatch/request/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.appointServcWorkVoucherEngineer = function (data, callback) {// 指派工程师
    api.post('/servcDeliv/servc/work/voucher/engineer/appoint/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.doServcWorkStaffQualiCheck = function (data, callback) {// 指派工程师验证工程师资质
    api.post('/servcDeliv/servc/work/staff/quali/check/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getServcWorkVoucherByReqVoucheId = function (data, callback) {// 通过服务请求单id获取服务工单详情
    api.post('/servcDeliv/servc/work/voucher/get/by/reqVoucheId')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getServcWorkAddItemList = function (params, callback) {
    api.get('/servcDeliv/servc/work/add/item/get')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getServcOrderChargeItemListByWorkVoucherId = function (params, callback) {// 通过工单id获取服务订单收费项
    api.get('/servcDeliv/servc/work/charge/item/list/get/by/workVoucherId')
        .params(params)
        .done(callback)
        .go();
};
exports.getServcWorkVoucherRecListByWorkVoucherId = function (params, callback) {// 通过工单id获取服务工单操作记录
    api.get('/servcDeliv/servc/work/voucher/rec/list/get/by/workVoucherId')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
// 统计-工程师工作量
exports.getEngineerWorkloadStatisListByComId = function (data, callback) {
    api.post('/servcDeliv/engineer/workload/statis/list/get/by/comId')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 网点业务统计  -  es 接口 - 已弃用
exports.getServicerShopWorkloadStatisList = function (data, callback) {
    api.post('/servcDeliv/servicerShop/workload/statis/list/get/by/context')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 导出服务网点工单报表，缓存过滤条件
exports.doServcShopWorkVoucherStatisListForExport = function (data, callback) {
    api.post('/servcDeliv/servicerShop/work/voucher/statis/list/export/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 代下工单
exports.saveServcWorkVoucherProxied = function (data, callback) {
    api.post('/servcDeliv/servc/work/voucher/proxied/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.getServcWorkVoucherByMasterIdList = function (data, callback) {// 通过服务订单id获取服务工单列表
    api.post('/servcDeliv/servc/work/voucher/paged/list/get/by/masterId')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.getCheckWorkVoucherByRefSrcId = function (data, callback) {
    api.get('/servcDeliv/check/work/voucher/By/refSrcId')
        .params(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.getDevcMaintVoucherById = function (params, callback) {
    api.get('/servcDeliv/devc/maint/voucher/get')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
//=================== 评价 ======================

// 获取评价列表
exports.getOrderServcEvalList = function (params, callback) {// 查询所有的评价列表
    api.post('/servcDeliv/eval/list/get')
        .data(params)
        .done(callback)
        .go();
};

// 评价详细信息
exports.getOrderServcEvalInfo = function (params, callback) {// 查询评价信息
    api.post('/servcDeliv/eval/info/get')
        .data(params)
        .done(callback)
        .go();
};

// ------------------- 查看维保记录 ----------------------
exports.getShopDeviceSvcSubNo = function (data, callback) {// 门店设备服务号详情
    api.post('/shop/devc/sub/no/get/by/svcSubNo')
        .data(data)
        .done(callback)
        .go();
};
//
exports.getServcWorkVoucherByTmpNo = function (data, callback) {// 根据tmpNo获取工单列表 - 【维保记录】
    api.post('/servcDeliv/servc/work/voucher/list/get/by/tmpNo')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// ------------------- 查看维保记录END ----------------------

// 获取工程师日常工作记录列表
exports.getEngiWorkDailyRec = function (data, callback) {
    api.post('/servcDeliv/engi/work/daily/rec/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getEngiWorkDailyRecByTypeFlags = function (data, callback) {
    api.post('/servcDeliv/engi/work/daily/rec/list/get/by/typeFlags')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getEngiWorkDailyRecSigninList = function (data, callback) {
    api.post('/servcDeliv/engi/work/daily/rec/signin/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getEngiWorkDailyRecSigninListForExport = function (data, callback) {
    api.post('/servcDeliv/engi/work/daily/rec/signin/export/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 服务工单安排计划
exports.updateServcWorkVoucherPlanTime = function (data, callback) {
    api.post('/servcDeliv/servc/work/voucher/update/planTime/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 设备检验信息
exports.getDevcInspectInfo = function (params, callback) {
    api.get('/servcDeliv/devc/inspect/info/get')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
// 工单批量设置绩效标记
exports.updateServcWorkVoucherPerformFlagBatch = function (data, callback) {
    api.post('/servcDeliv/servc/work/voucher/update/performFlag/batch/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.getServcWorkVoucherServicerTagList = function (data, callback) {// 通过服务订单结算标签列表
    api.post('/servcDeliv/servc/work/voucher/servicerTag/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 批量执行
exports.doBatchServicerTag = function (data, callback) {
    api.post('/servcDeliv/servc/work/voucher/servicerTag/batch/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 发起抢单
exports.updateGrabWork = function (data, callback) {
    api.post('/servcDeliv/grab/work/update')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 批量发起抢单
exports.updateGrabWorkBatch = function (data, callback) {
    api.post('/servcDeliv/grab/work/batch/update')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 查询工单人员要求资质
exports.getServcWorkStaffQualiListByVoucherId = function (data, callback) {
    api.post('/servcDeliv/servc/work/staff/quali/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getDeviceServcRecDtoList = function (data, callback) {
    api.post('/servcDeliv/device/servc/rec/list')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.saveServcWorkImgFile = function (data, callback) {
    api.post('/servcDeliv/servc/work/img/file/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.doConfirmCompleted = function (data, callback) {
    api.post('/servcDeliv/servc/work/voucher/check/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.getServcWorkImgFileListByVoucherId = function (params, callback) {
    api.get('/servcDeliv/servc/work/img/file/get/by/voucherId')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};

exports.getServcWorkImgFileList = function (data, callback) {
    api.post('/servcDeliv/servc/work/img/file/list')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.getServcWorkImgFileById = function (data, callback) {
    api.get('/servcDeliv/servc/work/img/file/get/by/id')
        .params(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.deleteServcWorkImgFile = function (data, callback) {
    api.post('/servcDeliv/servc/work/img/file/delete')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.updateSharedServcWorkImgFile = function (data, callback) {
    api.post('/servcDeliv/servc/work/img/file/shared/update')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.updateServcWorkImgFileTagName = function (postData, callback) {
    api.post('/servcDeliv/servc/work/img/file/update/tagName')
        .data(postData)
        .done(callback)
        .fail(callback)
        .go();
};
exports.updateServcWorkImgFile = function (data, callback) {
    api.post('/servcDeliv/servc/work/img/file/update')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getMaxWorkAttachFileCount = function (params, callback) {
    api.get('/servcDeliv/max/work/attach/file/count/get')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};

// 服务商备注
exports.updateServcWorkServicerMemo = function (data, callback) {
    api.post('/servcDeliv/servc/work/servicerMemo/update')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 需审核/无需审核
exports.updateServcWorkAuditRequired = function (data, callback) {
    api.post('/servcDeliv/servc/work/audit/required/update')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 工单审核
exports.doServcWorkTechAudit = function (data, callback) {
    api.post('/servcDeliv/servc/work/tech/audit/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// ------ 工单配件申领列表
exports.getServcWorkAccAppturnItemList = function (data, callback) {
    api.post('/servcDeliv/servc/work/acc/appturn/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 审核
exports.updateServcWorkAccAppturnItemForAudit = function (data, callback) {
    api.post('/servcDeliv/servc/work/acc/appturn/audit/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.checkGrabWorkServc = function (data, callback) {
    api.get('/servcDeliv/grab/work/servc/check')
        .params(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.doServcWorkGrab = function (data, callback) {
    api.post('/servcDeliv/servc/work/grab/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getGrabWorkServcList = function (data, callback) {
    api.post('/servcDeliv/servc/work/grab/servc/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/servcDeliv.js
// module id = 16
// module chunks = 1